export const steps = {
    STEP_START: 'start',
    STEP_PHONE: 'phone'
};
